// extracted by mini-css-extract-plugin
export default {"profile-image":"ProfileImage_profile-image__SVylA"};